// checkout script extends category script
import "~/base";

import Checkout from "~/app/components/checkout/Checkout.vue";
Vue.component("checkout", Checkout);
import InvoiceAddressSelectCheckout from "~/app/components/customer/addressSelectCheckoutCustom/InvoiceAddressSelect.vue"
Vue.component("invoice-address-select-checkout", InvoiceAddressSelectCheckout);
import ShippingAddressSelectCheckout from "~/app/components/customer/addressSelectCheckoutCustom/ShippingAddressSelect.vue"
Vue.component("shipping-address-select-checkout", ShippingAddressSelectCheckout);

import PaymentProviderSelect from "~/app/components/checkout/PaymentProviderSelect.vue"
Vue.component("payment-provider-select", PaymentProviderSelect);
import ShippingProfileSelect from "~/app/components/checkout/ShippingProfileSelect.vue"
Vue.component("shipping-profile-select", ShippingProfileSelect);
import Totals from "~/app/components/checkout/Totals.vue"
Vue.component("totals", Totals);
import AccountSettings from "~/app/components/myAccount/AccountSettings.vue"
Vue.component("account-settings", AccountSettings);

Vue.component("klarna-tracking", () => import("~/app/components/checkout/KlarnaTracking.vue"));
Vue.component("klarna-confirmation-tracking", () => import("~/app/components/checkout/KlarnaConfirmationTracking.vue"));

import "ceres/app/components/checkout/AcceptGtcCheck";
import "ceres/app/components/checkout/ContactWishInput";
import "ceres/app/components/checkout/CustomerSignInput";
import "ceres/app/components/checkout/PlaceOrder";
import "ceres/app/components/checkout/ShippingPrivacyHintCheck";
import "ceres/app/components/checkout/SubscribeNewsletterCheck";
import BasketItemConsentCheck from "ceres/app/components/checkout/BasketItemConsentCheck.vue";
Vue.component("basket-item-consent-check", BasketItemConsentCheck);

import "~/app/components/checkout/ShippingProfileSelectBasket";

import "ceres/app/components/customer/AddressSelect/AddressHeader";
import "~/app/components/customer/AddressSelect/InvoiceAddressSelect";
import "~/app/components/customer/AddressSelect/ShippingAddressSelect";

import "ceres/app/components/myAccount/BankDataSelect";
import "ceres/app/components/myAccount/ChangePaymentMethod";
import "ceres/app/components/myAccount/MyAccount";
import "ceres/app/components/myAccount/OrderDocuments";

// legacy non-shopbuilder components
import "~/app/components/myAccount/History";

// new shopbuilder-only component
import EditCouponOverlay from "ceres/app/components/myAccount/EditCouponOverlay.vue";
Vue.component("edit-coupon-overlay", EditCouponOverlay);import "~/app/components/myAccount/OrderHistoryList";
import "ceres/app/components/myAccount/OrderReturnHistoryList";
import Vue from "vue";
